import moment from 'moment'


export function toDate(dateValue) {
  return moment(dateValue).toDate()
}